<template>
  <v-container fluid class="pt-0">
    <v-row dense>
      <v-col cols="12" offset-lg="2" lg="8">
        <master-lines></master-lines>
      </v-col>

    </v-row>
  </v-container>
</template>

<script setup>
import MasterLines from '@/components/Master/MasterLines.vue'
</script>
<style scoped>
</style>
